import React, { Component } from "react";
import styled from "styled-components";

import { Link, NavLink } from "react-router-dom";
import HamburgerMenuIcon from "./HamburgerMenuIcon";
import WindowCloseIcon from "./WindowCloseIcon";
import "./styles.css";

// Styled components
const StyledNavLink = styled(NavLink)`
  text-decoration: none;
  color: #c0c0c0;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin: ${props => (props.sideBarIsOpen ? "15px" : "auto 15px")};
  /*Height is needed for IE; otherwise, margin-top and margin-bottom "auto" setting won't work */
  height: 1.5em;

  &:hover {
    color: orange;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.5px;
  }
`;

// For sidebarIsOpen error,
// see https://stackoverflow.com/questions/49358560/react-wrapper-react-does-not-recognize-the-staticcontext-prop-on-a-dom-elemen
const NavBarLinks = ({ onClick, sideBarIsOpen }) => (
  <React.Fragment>
    <StyledNavLink
      exact
      sideBarIsOpen={sideBarIsOpen}
      onClick={onClick}
      activeClassName="navbar__link--active"
      // class="navbar__link"
      to="/"
    >
      Home
    </StyledNavLink>
    <StyledNavLink
      sideBarIsOpen={sideBarIsOpen}
      onClick={onClick}
      activeClassName="navbar__link--active"
      // class="navbar__link"
      to="/find-my-trip"
    >
      Find My Trip
    </StyledNavLink>
  </React.Fragment>
);

class NavBar extends Component {
  constructor(props) {
    super(props);

    this.state = { sideBarIsOpen: false };
  }

  openSideBar = () => {
    this.setState({ sideBarIsOpen: true });
  };
  closeSideBar = () => {
    this.setState({ sideBarIsOpen: false });
  };
  render() {
    return (
      <div>
        <div class="navbar">
          <nav class="navbar__content container">
            {/* <!-- Brand and toggle get grouped for better mobile display --> */}
            {/* <Link class='navbar-brand' to='/'>FWDLOOK</Link> */}

            {/* <button class='btn btn-login'> Login </button> */}

            <Link class="navbar-brand" to="/">
              CATCHTRIPS
            </Link>
            <div class="navbar__right desktop-only">
              <NavBarLinks />
            </div>
            <HamburgerMenuIcon onClick={this.openSideBar} />
          </nav>
          <div
            class={`navbar__sidebar ${!this.state.sideBarIsOpen && "close"}`}
          >
            <div class="navbar__sidebar-content">
              <WindowCloseIcon onClick={this.closeSideBar} />
              <NavBarLinks
                onClick={this.closeSideBar}
                sideBarIsOpen={this.state.sideBarIsOpen}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/NavBar/index.js